import { swSettings } from "app/common/services/swSettings";
import { isLimitationExceeded } from "app/components/metering/MeteringState";
import type { GetMeteringData, IMeteringRawData } from "app/components/metering/types";
import { fetchMeteringData } from "app/components/metering/utils";
import { openHooksModalV5 } from "app/services/ModalService";
import { userRoleTitle } from "app/UtilitiesAndConstants/UtilityFunctions/userRoleUtils";

const ENDPOINT = "api/userdata/Metering/Industry";

const getHardLimitation = (): number => {
    return swSettings.components.Home.resources.NumCustomIndustriesHardLimit;
};

export const fetchIndustryAnalysisMeteringData = (): Promise<IMeteringRawData> => {
    return fetchMeteringData(ENDPOINT);
};

export const getMeteringData: GetMeteringData = (data) => {
    const { Count = 0, UserRole: userRole } = data;
    const allowedNum: number = swSettings.components.Home.resources.NumAllowedCustomIndustries;
    const allowedHardLimitation: number = getHardLimitation();

    if (!allowedNum) {
        return;
    }

    const isAdmin = userRole === userRoleTitle.ADMIN;

    return {
        count: Count,
        allowedNum,
        allowedHardLimitation,
        isAdmin,
    };
};

export const showIndustryAnalysisMeteringHook = () => {
    openHooksModalV5("IndustryAnalysisMetering");
};

export const isIndustryAnalysisLimitationExceeded = (): Promise<boolean> => {
    if (!getHardLimitation()) {
        return Promise.resolve(false);
    }

    return fetchIndustryAnalysisMeteringData().then((rawData: IMeteringRawData) => {
        const meteringData = getMeteringData(rawData);
        return isLimitationExceeded(meteringData);
    });
};
